module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Cobley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Michael Cobley")]), _vm._v(" was born in Leicester, England and has lived in Glasgow, Scotland for most of his life. He has studied engineering, been a DJ and has an abiding interest in democratic politics. "), _c('br'), _c('br'), _vm._v("His previous books include the Shadowkings dark fantasy trilogy and "), _c('I', [_vm._v("Iron Mosaic")]), _vm._v(", a short story collection. "), _c('I', [_vm._v("Seeds of Earth, The Orphaned Worlds")]), _vm._v(", and "), _c('I', [_vm._v("The Ascendant Stars")]), _vm._v(", books one, two and three of the Humanity's Fire sequence, were his first full-length forays into space opera.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZkTo8w/images/9780316214001.jpg?1733067587262",
      "alt": "This image is the cover for the book Orphaned Worlds, Humanity's Fire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Orphaned Worlds, Humanity's Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The fight is on. So let the battle begin."), _c('br'), _c('br'), _vm._v("Darien is no longer a lost outpost of humanity, but the prize in an intergalactic struggle. Hegemony forces control the planet, while Earth merely observes, rendered impotent by galactic politics. Yet Earth's ambassador to Darien will become a player in a greater conflict as there is more at stake than a turf war on a newly discovered world. "), _c('br'), _c('br'), _vm._v("An ancient temple hides access to a hyperspace prison, housing the greatest threat sentient life has never known. Millennia ago, malignant intelligences were caged there following an apocalyptic struggle, and their servants work on their release. Now a new war is coming.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0